import { render, staticRenderFns } from "./StudentPreviousObjectives.vue?vue&type=template&id=9baf7836&scoped=true&lang=pug&"
import script from "./StudentPreviousObjectives.vue?vue&type=script&lang=ts&"
export * from "./StudentPreviousObjectives.vue?vue&type=script&lang=ts&"
import style0 from "./StudentPreviousObjectives.vue?vue&type=style&index=0&id=9baf7836&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9baf7836",
  null
  
)

export default component.exports